import { useMobileEdgeChromeStore } from "../../stores/mobileEdgeChromeStore";

export function isPointerOverLibraryPanel(pointer) {
  if (!pointer || !Number.isFinite(pointer.x) || !Number.isFinite(pointer.y)) return false;
  if (useMobileEdgeChromeStore.getState().immersiveLibraryDragActive) {
    return false;
  }
  // Prefer geometry: `elementFromPoint` often hits the WebGL canvas or drag overlay even when
  // the pointer is over the library panel (stacking / transparent layers).
  const roots = document.querySelectorAll("[data-library-panel-root]");
  for (let i = 0; i < roots.length; i += 1) {
    const r = roots[i].getBoundingClientRect();
    if (
      pointer.x >= r.left &&
      pointer.x <= r.right &&
      pointer.y >= r.top &&
      pointer.y <= r.bottom
    ) {
      return true;
    }
  }
  const hit = document.elementFromPoint(pointer.x, pointer.y);
  return Boolean(hit?.closest?.("[data-library-panel-root]"));
}

/** Inspector / mesh drop targets: suppress scene placement preview for mesh-asset library drags. */
export function isPointerOverPropertiesPanel(pointer) {
  if (!pointer || !Number.isFinite(pointer.x) || !Number.isFinite(pointer.y)) return false;
  const roots = document.querySelectorAll("[data-properties-panel-root]");
  for (let i = 0; i < roots.length; i += 1) {
    const r = roots[i].getBoundingClientRect();
    if (
      pointer.x >= r.left &&
      pointer.x <= r.right &&
      pointer.y >= r.top &&
      pointer.y <= r.bottom
    ) {
      return true;
    }
  }
  const hit = document.elementFromPoint(pointer.x, pointer.y);
  return Boolean(hit?.closest?.("[data-properties-panel-root]"));
}

export function shouldSuppressMeshAssetSceneLibraryDrop(dragData, pointer) {
  if (!dragData || dragData.itemType !== "meshAsset") return false;
  return isPointerOverPropertiesPanel(pointer);
}
